import axiosInstance from "./axiosInstance";
import { log, LogLevel } from "utils/LogUtil";

type DeviceType = "ios" | "android" | "browser";

interface RegisterFcmTokenResponse {
  id: number;
  deviceType: DeviceType;
}

interface DeleteFcmTokenResponse {
  deleted: boolean;
}

/** FCM 토큰 백엔드 등록 */
export const registerFcmToken = async (
  fcmToken: string,
  deviceType: DeviceType
): Promise<RegisterFcmTokenResponse> => {
  try {
    const response = await axiosInstance.post<RegisterFcmTokenResponse>(
      "/api/v1/fcm/token",
      { fcmToken, deviceType }
    );
    return response.data;
  } catch (error) {
    log(LogLevel.ERROR, "FCM 토큰 백엔드 등록 실패:", error);
    throw error;
  }
};

/** FCM 토큰 백엔드 삭제 */
export const deleteFcmToken = async (
  fcmToken: string
): Promise<DeleteFcmTokenResponse> => {
  try {
    const response = await axiosInstance.delete<DeleteFcmTokenResponse>(
      "/api/v1/fcm/token",
      { data: { fcmToken } }
    );
    return response.data;
  } catch (error) {
    log(LogLevel.ERROR, "FCM 토큰 백엔드 삭제 실패:", error);
    throw error;
  }
};
